import { AnalyticsWrapper } from "@mod/core/config/initialize-analytics";
import { Outlet } from "react-router-dom";

export const MainLayout = () => {
  return (
    <div className="flex flex-col bg-white">
      {/* <MainHeader /> */}
      <AnalyticsWrapper />
      <main className="flex-grow overflow-auto min-h-screen">
        <Outlet />
      </main>
      {/* <FooterWrapper /> */}
    </div>
  );
};
